import { Container, Grid, Box, Skeleton } from '@mui/material';
import React, { FC } from 'react';

const WhyJoinSectionSkeleton: FC<any> = () => {
  return (
    <Box py={{ lg: 11, md: 9, sm: 6 }}>
     <Container maxWidth="xl">
          <Grid container spacing={{ lg: 10, md:8,  sm: 6 }}>
              {[...Array(4).keys()].map((item) => (
                  <Grid item lg={3} md={6} sm={12} key={item}>
                    <Skeleton variant="rectangular" width={40} height={40} />
                    <Skeleton variant="text" height={60} width="80%" />
                    <Skeleton variant="rectangular" height={100} />
                  </Grid>
               ))}
          </Grid>
     </Container>
     </Box>
  );
};

export { WhyJoinSectionSkeleton };